import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { paths } from "../../navigation/paths";
import { useAuthUser } from "./useAuthUser";

export const useAuth = () => {
  const { user, checkedAuth } = useAuthUser();
  const history = useHistory();

  useEffect(() => {
    if (!checkedAuth) return;
    if (!user) history.push(paths.auth.login);
  }, [checkedAuth, history, user]);

  // returning these shouldn't really be this hooks job but to prevent
  // needing to call useAuthUser again when its already use in here
  return { user, checkedAuth };
};
